import React from "react";

import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import {Button} from "reactstrap";
import ReactTable from "react-table";
import {Link} from "react-router-dom";
import moment from "moment";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CollectionOverride from "components/CollectionOverride";
import {confirmAlert} from "react-confirm-alert";
import API from "@beardeddevops/react.api";



export default class NicsDenied extends CollectionOverride {
	constructor(props) {
		super(props, Types.Customers._name);
		this.state.limit = 3;
		this.limit = 3;
		this.request = 'GET_DENIED';
	}
	handleRemoveCustomerNicsDenied = async(customer) => {
		const {pkey, binary_id, name_first, name_last} = customer.original;
		confirmAlert({
			title: 'Confirm Delete',
			message: `Are you sure you want to delete ${name_first} ${name_last}'s record from NICS Denied`,
			buttons: [
				{
					label: 'Yes',
					color: 'danger',
					onClick: async () => {
						this.model.object = customer.original;
						this.model.object.nics_denied = 0;
						try {
							await this.model.submit(null, API.RequestType.UPDATE);
						} catch (error) {
						}
						this.model.object.pkey = '';
						this.model.object.binary_id = '';
						this.setState({key: Math.random()})
					}
				},
				{
					label: 'No',
					onClick: () => {
					}
				}
			]
		});
	}

	render() {
		const {data, pages, limit, loading} = this.state;
		const columns = [
			{
				Header: "Denied Name",
				accessor: "pkey",
				Cell: props => <Link
					to={"/customers/" + props.original.binary_id + '-' + props.value}>{props.original.name_first} {props.original.name_last}</Link>
			},
			{
				Header: "Address",
				id: "customer_addresses.street_1",
				/** @param {Customers_Object} obj */
				accessor: obj => (obj.customer_addressess && obj.customer_addressess.length > 0 && obj.customer_addressess[0].street_1) ? obj.customer_addressess[0].street_1 + ' ' + obj.customer_addressess[0].city + ', ' + obj.customer_addressess[0].state + ' ' + obj.customer_addressess[0].zip : '-'
			},
			{
				Header: "DOB",
				id: "birth_date",
				width: 100,
				/** @param {Customers_Object} obj */
				accessor: obj => {
					return obj.birth_date ? moment(obj.birth_date).local().format("MM/DD/YYYY") : '-'
				}
			},
			{
				Header: "Date Denied",
				id: "nics_denied_date",
				width: 100,
				/** @param {Customers_Object} obj */
				accessor: obj => {
					return obj.nics_denied_date ? moment(obj.nics_denied_date).local().format("MM/DD/YYYY") : '-'
				}
			},
			{
				Header: "",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 40,
				Cell: props => {
					return (
						<span>
							<Link to={`/customers/${props.original._id}`}>
								<Button color="green-meadow" size="sm" block={true}>
									<i className="fa fa-pencil"/>
								</Button>
							</Link>
						</span>
					);
				}
			},
			{
				Header: "",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 40,
				Cell: props => {
					return (
						<span>
						<Button color="danger"
						        size="sm"
						        block={true}
						        onClick={() => this.handleRemoveCustomerNicsDenied(props)}
						>
							<i className="fa fa-times"/>
						</Button>
						</span>
					)
				}
			}
		];

		return (
			<Card>
				<CardContent>
					<div className="table-bar">
						<div className="d-flex">
							{this.renderSearch('NICS Denied', "")}
							{this.renderHeaderRight("NICS Denied", columns)}
						</div>
					</div>
					<ReactTable
						key={this.state.key}
						columns={columns}
						manual // Forces table not to paginate or sort automatically, so we can handle it server-side
						data={data}
						pages={pages} // Display the total number of pages
						loading={loading} // Display the loading overlay when we need it
						loadingText="Requesting Data"
						onFetchData={this.fetchData} // Request new data when things change
						onPageSizeChange={this.onPageSizeChange}
						onSortedChange={this.onSortedChange}
						page={this.state.page}
						onPageChange={this.onPageChange}
						expanderDefaults={{
							sortable: true,
							resizable: true,
							filterable: false,
							width: undefined
						}}
						defaultSorted={[
							{
								id: this.model.sort,
								desc: this.model.order === 'desc'
							}
						]}
						showPagination={true}
						showPaginationTop={false}
						showPaginationBottom={true}
						showPageSizeOptions={true}
						defaultPageSize={limit}
						pageSize={limit}
						pageSizeOptions={[3, 5, 10, 20, 25, 50, 100, 500, 1000]}
						className="-striped -highlight"
					/>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}
